import './App.css';
import React from 'react';
import Dashboard from './componentes/Dashboard';
import Login from './componentes/Login';
import {Route, Routes } from 'react-router-dom';
import RequireAuth from './componentes/RequireAuth';
import ToolsConvenioWeb from './componentes/ToolsConvenioWeb'
import PainelAPI from './componentes/PainelAPI';
import PainelPIX from './componentes/PainelPIX';
import ToolsGestorMob from './componentes/ToolsGestorMob';
import PainelIFOOD from './componentes/PainelIFOOD';
import ConsultaDinamica from './componentes/ConsultaDinamica';

function App() {

  return (

 <Routes>

      <Route path="/" element={<Login />} />
     <Route element={<RequireAuth />}>
     
     <Route path="/dashboard/all" element={<Dashboard />} />
     <Route path="/dashboard" element={<Dashboard />} />
     <Route path="/dashboard/toolsconvenioweb" element={<ToolsConvenioWeb />} />
     <Route path="/dashboard/API" element={<PainelAPI />} />
     <Route path="/dashboard/PainelPix" element={<PainelPIX />} />
     <Route path="/dashboard/toolsgestormob" element={<ToolsGestorMob />} />
     <Route path="/dashboard/PainelIFOOD" element={<PainelIFOOD />} />
     <Route path="/dashboard/ConsultaDinamica" element={<ConsultaDinamica />} />
     </Route> 
 
   </Routes>

  );
}

export default App;
